import * as React from "react";

type LoaderSize = "tiny" | "small" | "medium" | "large";

interface LoaderProps {
  title?: string;
  subtitle?: string;
  size?: Exclude<LoaderSize, "small">;
}

interface SpinnerProps {
  size?: LoaderSize;
}


export const SpreetailSpinner: React.FC<SpinnerProps> = ({ size = "medium" }) => {
  const pixelSize =
    size === "tiny" ? 14 : size === "small" ? 18 : size === "medium" ? 24 : 32;
  const borderWidth = size === "tiny" ? 2 : size === "small" ? 2 : 3;

  return (
    <>
      <div
        style={{
          width: pixelSize + 10,
          height: pixelSize + 10,
          borderRadius: "999px",
          background:
            "radial-gradient(circle at center, rgba(6,142,117,0.18), transparent 70%)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: pixelSize,
            height: pixelSize,
            borderRadius: "999px",
            border: `${borderWidth}px solid rgba(148,163,184,0.35)`,
            borderTopColor: "#068E75",
            boxSizing: "border-box",
            animation: "st-spin 0.8s linear infinite",
          }}
        />
      </div>
      <style>
        {`
          @keyframes st-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};


const SpreetailLoader: React.FC<LoaderProps> = ({
  title = "Working on your data",
  subtitle = "Please wait while we generate your data",
  size = "large",
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 16,
      }}
    >
      <SpreetailSpinner size={size === "large" ? "large" : "medium"} />
      {(title || subtitle) && (
        <div style={{ maxWidth: 320 }}>
          {title && (
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#0F172A",
                marginBottom: subtitle ? 4 : 0,
              }}
            >
              {title}
            </div>
          )}
          {subtitle && (
            <div
              style={{
                fontSize: 13,
                color: "#667085",
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SpreetailLoader;

